import { ActionCreator, Action } from "redux";
import { ThunkAction } from 'redux-thunk';
import { FirebaseReducer } from "react-redux-firebase";
import { RouteComponentProps } from 'react-router-dom';

declare module 'react-typeform-embed';
declare module 'node-forge';

export enum AuthTypes {
  GOOGLE_API_URL = "https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=",
  DUMMY = "DUMMY",
  LOGIN = "LOGIN",
  AUTHENTICATED = "AUTHENTICATED",
  GOOGLE_LOGIN = "GOOGLE_LOGIN",
  FACEBOOK_LOGIN = "FACEBOOK_LOGIN",
  LOGOUT = "LOGOUT",
  LOAD_USER = "LOAD_USER",
};
export enum UserActions {
  LOGIN = 'LOGIN',
  FETCH_USER = 'FETCH_USER',
  SIGN_UP = 'SIGN_UP',
  LOGOUT = 'LOGOUT',
};

export enum PlanActions {
  FETCH_PLANS = "FETCH_PLANS",
  SET_BASIC_PLAN_MODAL = 'SET_NEW_PLAN_MODAL',
  SET_PLAN_TYPE = 'SET_PLAN_TYPE',
  SET_PLAN_OPTIONS = 'SET_PLAN_OPTIONS',
  GENERATE_RETIREMENT_PLAN = 'GENERATE_RETIREMENT_PLAN',
  SET_ERROR_DETAILS_MODAL = 'SET_ERROR_DETAILS_MODAL',
  DOWNLOAD_PLAN = 'DOWNLOAD_PLAN',

}

export enum BankAccountTypes {
  GET_BANKS = "GET_BANKS",
  GET_BANK_FIELDS = "GET_BANK_FIELDS",
  CREATE_USER = "CREATE_USER",
}

export enum PlanType {
  ORIGINAL = 'original',
  ORGINAL_RETROACTIVE = 'retroactivo',
  BASIC = 'basic',
  RETROACTIVE = 'retroactive',
  CUSTOM = 'custom',
  DIAGNOSTIC = 'diagnostico',
  STUDY = 'estudio',
}

export function getEnumKeyByEnumValue<T extends {[index:string]:string}>(myEnum:T, enumValue:string):keyof T|null {
  let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}

export type UserState = {
  user: Maybe<AppUser>;
  loading: boolean;
  loggingIn: boolean;
  loginSuccess: boolean;
  fetchingData: boolean;
  fetchDataError: boolean;
  loginError: boolean;
  fetchingUser: boolean;
  fetchUserError: boolean;
  signingUp: boolean;
  signUpError: boolean;
  signUpSuccess: boolean;
};

export type PlansState = {
  basicPlanModalPlanType: string;
  basicPlanModalOpen: boolean;
  errorModalOpen: boolean;
  selectedPlan: Maybe<PlanDoc>;
  fetchingPlans: boolean;
  fetchPlanError: boolean;
  planOptionsOpen: boolean;
  selectedPlanType: Maybe<PlanType>;
  plans: PlanDoc[];
  downloadingPlan: boolean;
};

export type FieldInputs = {
  planId: string,
  investment_scenarios: number[],
  civil_status: string,
  edge_case: boolean,
  mod_40_scenarios: number[],
  reactivation_wage: number,
  alive_parents_num: number,
  has_partner: boolean,
  user_email: string,
  plan_type: PlanType,
  flavour: string,
};

export type SavedPlanInput = {
  planId: string,
  investment_scenarios?: string,
  civil_status: string,
  edge_case: boolean,
  mod_40_scenarios?: string,
  reactivation_wage: number,
  alive_parents_num: number,
  has_partner: boolean,
  user_email: string,
  plan_type: PlanType,
  flavour: string,
};

export type AppState = {
  user: UserState,
  plans: PlansState,
  firebase: FirebaseReducer.Reducer
};

export type PlanError  = {
  code: number;
  message: string;
};

export type PlanKind = 'blocked' | 'unblocked';

export type PlanData = {
  ref: string;
  url: string;
  type: PlanKind;
}

export type RscData = {
  ref: string;
  url: string;
}

export type PlanDoc = {
  id: string;
  plan_type: string;
  user_name: string;
  rsc: RscData;
  advisor_id: string;
  success: boolean;
  created_at: number;
  building: boolean;
  stars: number;
  tags: Array<{ id: string, friendly_name: string, value: number }>;
  error: PlanError;
  inputs: SavedPlanInput;
  plans: PlanData[];
  type: PlanType;
  diagnostic_data: Maybe<string>;
};

export type AppUser = {
  email: string,
  id: string,
  flavour: Maybe<string>,
  available_pdfs: number
};

export type PlanInput = FieldInputs & {
  file: any,
};


export type AppThunk = ActionCreator<
  ThunkAction<void, UserState, null, Action<string>>
>;


export enum CloudFunctions {
  FIREBASE_SIGN_UP = 'firebaseSignUp',
  FETCH_APP_USER = 'fetchAppUser',
  CHECK_TYPEFORM_STATUS = 'checkTypeformStatus',
  CREATE_EMPTY_USER = 'user-createEmptyUser',
  CREATE_APP_USER = 'user-createAppUser',
  CREATE_USER_SR_PAGO = 'srpago-createUserSrPago',
  DUMMY_CALLABLE_CF = 'rule-dummyCallableCloudFunction',
  GET_RULES = 'rule-getRules',
  UPDATE_RULE = 'rule-updateRule',
  DELETE_RULE = 'rule-deleteRule',
  GET_BANKS = 'finerio-getBanks',
  GET_BANK_FIELDS = 'finerio-getBankFields',
  CREATE_USER_FINERIO = 'finerio-createUser',
  SAVE_ONBOARDING_DATA = 'saveOnboardingData',
  FETCH_ONBOARDING_DATA = 'fetchOnboardingData',
  FETCH_PERIODIC_RULE = 'fetchPeriodicRule',
  FETCH_PIN_HASH = 'fetchPinHash',
  UPDATE_PERIODIC_RULE = 'updatePeriodicRule',
  FETCH_TRANSACTIONS = 'fetchTransactions',
  FETCH_SAVINGS = 'fetchSavings',
};

export interface ChildProps extends RouteComponentProps<any> { };

export type Maybe<T> = T | null | undefined;

export type UserCredentials = {
  name: string,
  email: string,
  password: string,
};

export enum TransactionStatus {
  Ok,
  Error
};